import { SceneElement } from 'types/api'

export const SNAP_SCREEN_PX = 6

export const MAX_ELEMENT_SIZE = 8000

export const MIN_VISUAL: Record<SceneElement['elementKind'], { w: number, h: number }> = {
  POLL: { w: 150, h: 0 },
  TUG: { w: 300, h: 60 },
  BOARD: { w: 150, h: 40 },
  CHAT: { w: 160, h: 160 },
  EMOTEWALL: { w: 160, h: 160 },
  MERCH: { w: 400, h: 0 },
  MERCH_TICKER: { w: 480, h: 0 },
  CAMERA_CONTROL: { w: 160, h: 0 },
  GIVEAWAY: { w: 480, h: 0 },
  TRIVIA: { w: 150, h: 0 }
}

export const clampRange = (n: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, n))

export interface Rect {
  left: number
  top: number
  right: number
  bottom: number
}

export interface GuideCandidates {
  vertical: number[]
  horizontal: number[]
}

export const collectGuideCandidates = (
  rects: Rect[],
  canvasW: number,
  canvasH: number
): GuideCandidates => ({
  vertical: [canvasW / 2, ...rects.flatMap((r) => [r.left, (r.left + r.right) / 2, r.right])],
  horizontal: [canvasH / 2, ...rects.flatMap((r) => [r.top, (r.top + r.bottom) / 2, r.bottom])]
})

export interface AxisSnap {
  delta: number
  guide: number
}

export const snapPositions = (
  positions: number[],
  candidates: number[],
  threshold: number
): AxisSnap | null => {
  let best: AxisSnap | null = null
  for (const candidate of candidates) {
    for (const position of positions) {
      const delta = candidate - position
      if (Math.abs(delta) <= threshold && (best === null || Math.abs(delta) < Math.abs(best.delta))) {
        best = { delta, guide: candidate }
      }
    }
  }
  return best
}

export const snapEdge = (
  edge: number,
  candidates: number[],
  threshold: number
): AxisSnap | null => snapPositions([edge], candidates, threshold)

export const elementsEqual = (a: SceneElement[], b: SceneElement[]): boolean =>
  a.length === b.length && a.every((el, i) => {
    const other = b[i]
    return el.elementKind === other.elementKind &&
      el.elementId === other.elementId &&
      el.x === other.x &&
      el.y === other.y &&
      el.z === other.z &&
      el.scale === other.scale &&
      el.visible === other.visible &&
      el.w === other.w &&
      el.h === other.h
  })
